// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2xG_y","link":"styles_link__1u4r5"};